import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AccountModeService } from './account-mode.service';
import { AuthService } from './auth.service';
import { WebTokenBridge } from '../web-auth/web-token.bridge';

/** Keycloak oturumlu (eski) organizasyon hesabının ana sayfası. */
export const MEMBERSHIP_ROUTE = ['/templates/membership'];
/** Org web oturumu ya da Üyelik kurumunun ent oturumu: bütün Organizasyon işleri /org altında. */
export const ORG_HOME_ROUTE = ['/org'];

/**
 * Organizasyon modundaki hesabı ana sayfa (deneme/abonelik kartları) ve abonelik sayfası yerine
 * Organizasyon ana sayfasına götürür: org/ent web oturumunda /org, Keycloak oturumlu eski hesapta Üyelik sayfası. Kurumsal hesapta (ve kart v2 bayrağı kapalıyken) hiçbir şey değişmez.
 * adminGuard ile aynı neden: sayfa yenilemede token eşzamansız döner, önce oturum beklenir.
 * İlk girişteki kurum açma (bekleyen "organizasyon" seçimi) da burada, yönlendirmeden önce biter.
 */
export const organizationModeGuard: CanActivateFn = async () => {
    const auth = inject(AuthService);
    const router = inject(Router);
    const accountMode = inject(AccountModeService);
    const bridge = inject(WebTokenBridge);
    await auth.whenSessionReady();
    const mode = await accountMode.resolve();
    if (mode !== 'organization') return true;
    const webOrg = bridge.isEnt() || !auth.getAccessToken();
    return router.createUrlTree(webOrg ? ORG_HOME_ROUTE : MEMBERSHIP_ROUTE);
};

/**
 * Yalnız Üyelik (organizasyon) oturumuna açık rotaların kapısı (menüde yalnız o oturumda görünen /templates/membership).
 * Şirket (kurumsal) oturumu URL ile girerse ana sayfaya düşer; orada organizationModeGuard
 * zaten oturum türüne göre doğru sayfaya götürür. /templates/consent-documents bu kapının dışındadır: Şirket formları da belge bağlar.
 */
export const organizationOnlyGuard: CanActivateFn = async () => {
    const auth = inject(AuthService);
    const router = inject(Router);
    const accountMode = inject(AccountModeService);
    await auth.whenSessionReady();
    const mode = await accountMode.resolve();
    return mode === 'organization' ? true : router.parseUrl('/');
};
